import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { PerfectScrollbarComponent } from './perfect-scrollbar.component'

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        PerfectScrollbarComponent,
    ],
    exports: [
        PerfectScrollbarComponent,
    ],
})
export class PerfectScrollbarModule {
}